import {
  ColoredIconTypes,
  IconTypes,
} from "@brexhq/shared/components/deprecated/Icons/types";
import type { BreakPointVals } from "@brexhq/shared/styles/breakpoints";
import { IBynderImageWithBorderRadius } from "@brexhq/shared/types/BynderAsset";
import { ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";
import type { SanityLink } from "@brexhq/shared/types/SanityLink";
import type { ModuleLayoutProps } from "@brexhq/shared/types/modules/ModuleLayout";

export type SlideStyles = Record<
  Extract<BreakPointVals, "LRG" | "SML">,
  number
>;

export interface SwipeCardCarouselContainerProps {
  moduleTheme: ModuleThemeType;
}

export interface SwipeCardCarouselControllerProps {
  moduleTheme: ModuleThemeType;
}

export const TEST_ID_CARRIAGE = "CARRIAGE";

export const DESKTOP_CARD_WIDTH = 380;
export const MOBILE_CARD_WIDTH = 260;

export type DragDirection = "left" | "right" | "none";
export type ScrollStyle = "scroll" | "drag" | "scrollButtons";

export interface DefaultCarouselCardProps {
  alignment: "left" | "center";
  moduleTheme: ModuleThemeType;
  headerPortableText?: any[];
  bodyPortableText?: any[];
  image?: IBynderImageWithBorderRadius | null;
  primaryIcon?: ColoredIconTypes;
  secondaryIcon?: IconTypes;
  buttonText?: string;
  width: SlideStyles;
  margin: SlideStyles;
  id: string;
  cardUrl?: string;
  cardTheme?: ModuleThemeType;
}

export interface TransformedCarouselCardProps {
  renderedCard: React.ReactNode;
  cardWidth: SlideStyles;
  id: string;
  cardUrl?: string;
}

export interface SwipeCarouselModuleProps {
  cards: Array<TransformedCarouselCardProps>;
  moduleLayout: ModuleLayoutProps;
  cardWidth: SlideStyles;
  cardTheme?: ModuleThemeType;
}

// Sanity Data
export interface SwipeCardData {
  image: IBynderImageWithBorderRadius | null;
  primaryIcon?: {
    icon: ColoredIconTypes;
  };
  secondaryIcon?: {
    icon: IconTypes;
  };
  headerPortableText?: any[];
  bodyPortableText?: any[];
  buttonText?: string;
  cardUrl: SanityLink;
}

export interface CarouselSwipeCardsData {
  alignment: "left" | "center";
  moduleLayout: ModuleLayoutProps;
  cards: Array<SwipeCardData>;
  cardTheme: ModuleThemeType;
}

export interface CarouselSwipeCardsProps {
  data: CarouselSwipeCardsData;
}
